import React, { useState, useEffect} from 'react';
import './css/App.css';
import { SpinnerComp } from './helper/spinner';
import { Button, Container, Row, Col, Alert } from 'react-bootstrap'
import Talk from './helper/Talk'
import { postMultipartToApi, getFromApi } from './utilities/NetUtilities';
import { buildUrl } from './helper/handler';

function CaricaFile() {

    const [message, setMessage] = useState([]);
    const [warning, setWarning] = useState([]);
    const [error, setError] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState("");
    const [isFilePicked, setIsFilePicked] = useState("");
    const [inputKey, setInputKey] = useState(Date.now());
    const [nomeOrganizzazione, setNomeOrganizzazione] = useState("")
    const [tipoOrganizzazione, setTipoOrganizzazione] = useState("")
    const [nonCrystallizedWeeks, setNonCrystallizedWeeks] = useState([]);

    const fatture = "fatture";
    const numero730 = "numero730";
    const appuntamenti = "appuntamenti";
    const isee = "isee";
    const disponibilita = "disponibilita";
    const url_fatture = "uploadfatture";
    const url_numero730 = "uploadnumero730";
    const url_appuntamenti = "uploadappuntamenti";
    const url_isee = "uploadisee";
    const url_disponibilita = "uploaddisponibilita";

    useEffect(() => {
        const init = async () => {
            const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"))
            if (organizzazioneMap) {
                setNomeOrganizzazione(organizzazioneMap.nome)
                setTipoOrganizzazione(organizzazioneMap.tipo)
                loadRiepilogoTotale(organizzazioneMap.nome, organizzazioneMap.tipo);
            }
        }   
        init();
      }, [])

    const loadRiepilogoTotale = (orgNome, orgTipo) => {
        const url = buildUrl('riepilogototale', {
            organizzazione: orgNome,
            tipo: orgTipo,
            tutti: false
        });
        const okAction = (data) => {
            if (data && data.dati) {
                const currentYear = new Date().getFullYear();
                const currentYearData = data.dati[currentYear];
                if (currentYearData && currentYearData.tabellaRiepilogoTotale && currentYearData.tabellaRiepilogoTotale.settimane) {
                    const settimanaCorrente = currentYearData.settimanacorrente || -1;
                    if (settimanaCorrente > 0) {
                        const weeks = Object.values(currentYearData.tabellaRiepilogoTotale.settimane);
                        const missing = weeks
                            .filter(w => w.numero < settimanaCorrente && !w.cristallizzato)
                            .sort((a, b) => a.numero - b.numero);
                        setNonCrystallizedWeeks(missing);
                    }
                }
            }
        };
        const nokAction = (err) => {
            console.error("Errore caricamento riepilogo totale per controllo cristallizzazioni:", err);
        };
        getFromApi(url, okAction, nokAction);
    };

    const changeHandler = (event) => {
        setSelectedFile(event.target.files[0]);
        setIsFilePicked(event.target.name);
        setMessage([]);
        setWarning([]);
        setError([]);
    };

    const okAction = (data) => {
        setLoading(false)
        const errori = [];
        const warning = [];
        const messaggi = [];
        data.messaggi.forEach((actual) => {
            if (actual.tipo === 'danger') {
                errori.push(actual.descrizione);
            }
            if (actual.tipo === 'warning') {
                warning.push(actual.descrizione);
            }
            if (actual.tipo === 'info') {
                messaggi.push(actual.descrizione);
            }
        })
        setMessage(messaggi);
        setWarning(warning);
        setError(errori);
    }

    const nokAction = (data) => {
        setLoading(false)
        setMessage([]);
        if(data.messaggi[0].tipo === "warning") {
            setWarning([data.messaggi[0].descrizione]);
        } else {
            setError([data.messaggi[0].descrizione]);
        }
    }

    const handleSubmission = (controller, tipo) => {
        const formData = new FormData();
        formData.append(tipo, selectedFile);
        formData.append("organizzazione", nomeOrganizzazione)
        formData.append("tipo", tipoOrganizzazione)
        const url = buildUrl(controller)
        if (isFilePicked === tipo) {
            setLoading(true);
            postMultipartToApi(url, formData, okAction, nokAction);
            setSelectedFile(false);
            setInputKey(Date.now);
            setIsFilePicked("");
        }
        else {
            const listMessage = ["scegliere un file"];
            setMessage(listMessage);
        }
    };

    if (loading === true) {
        return <SpinnerComp />
    }

    return (
        <div className='main2' role='main'>
            <Container fluid>
                <Talk messaggi={message} warning={warning} errori={error} />
                {nonCrystallizedWeeks.length > 0 && (
                    <Alert id="warning_cristallizzazione" variant="warning" className="text-center mt-3">
                        <div className="text-start d-inline-block">
                            Attenzione, le seguenti settimane dell'anno in corso antecedenti a quella attuale non sono ancora state cristallizzate:
                            <div className="mt-2 mb-2" style={{ paddingLeft: '15px' }}>
                                {nonCrystallizedWeeks.map(w => (
                                    <div key={w.numero} className="mb-1">
                                        • Settimana {w.numero} ({w.descrizione})
                                    </div>
                                ))}
                            </div>
                            Si consiglia di cristallizzarle prima di caricare nuovi dati.
                        </div>
                    </Alert>
                )}
                <h1 className="d-flex justify-content-center">Importazione dati 
                ({nomeOrganizzazione.toLowerCase()}/{tipoOrganizzazione.toLowerCase()})</h1>
                <div className="space divCaricaFile">
                    <Row>
                        <Col xs lg="3">
                            <p className="form-label labelfile ">File fatturato</p>
                        </Col>
                        <Col xs lg="7">
                            <input className="form-control form-control-lg" id="inputFileFattura" aria-label='File fatturato' type="file" name={fatture} onChange={changeHandler} key={inputKey} />
                        </Col>
                        <Col xs lg="2">
                            <Button className="btnGenerale" variant="flat" size="sm" id="carica_fattura" onClick={() => handleSubmission(url_fatture, fatture)}>Carica</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs lg="3">
                            <p className="form-label labelfile">File numero 730</p>
                        </Col>
                        <Col xs lg="7">
                            <input className="form-control form-control-lg" id="inputFile730" aria-label='File numero 730' type="file" name={numero730} onChange={changeHandler} key={inputKey} />
                        </Col>
                        <Col xs lg="2">
                            <Button className="btnGenerale" variant="flat" size="sm" id="carica_numero730" onClick={() => handleSubmission(url_numero730, numero730)}>Carica</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs lg="3">
                            <p className="form-label labelfile">File appuntamenti</p>
                        </Col>
                        <Col xs lg="7">
                            <input className="form-control form-control-lg" id="inputFileAppuntamenti" aria-label='File appuntamenti' type="file" name={appuntamenti} onChange={changeHandler} key={inputKey} />
                        </Col>
                        <Col xs lg="2">
                            <Button className="btnGenerale" variant="flat" size="sm" id="carica_appuntamenti" onClick={() => handleSubmission(url_appuntamenti, appuntamenti)}>Carica</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs lg="3">
                            <p className="form-label labelfile">File isee</p>
                        </Col>
                        <Col xs lg="7">
                            <input className="form-control form-control-lg" id="inputFileIsee" aria-label='File isee' type="file" name={isee} onChange={changeHandler} key={inputKey} />
                        </Col>
                        <Col xs lg="2">
                            <Button className="btnGenerale" variant="flat" size="sm" id="carica_isee" onClick={() => handleSubmission(url_isee, isee)}>Carica</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs lg="3">
                            <p className="form-label labelfile">File disponibilità</p>
                        </Col>
                        <Col xs lg="7">
                            <input className="form-control form-control-lg" id="inputFileDisponibilita" aria-label='File disponibilità' type="file" name={disponibilita} onChange={changeHandler} key={inputKey} />
                        </Col>
                        <Col xs lg="2">
                            <Button className="btnGenerale" variant="flat" size="sm" id="carica_disponibilita" onClick={() => handleSubmission(url_disponibilita, disponibilita)}>Carica</Button>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    )
}

export default CaricaFile;